import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export default function ParallaxImage({
  src,
  alt = "",
  className = "",
  strength = 12,
  priority = false,
  kenburns = false,
  imgPosition = "center",
}) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [`-${strength}%`, `${strength}%`]);
  const scale = 1 + (strength * 2 + 12) / 100;

  return (
    <div ref={ref} className={`overflow-hidden ${className}`}>
      <div className={`absolute inset-0 ${kenburns ? "kenburns" : ""}`}>
        <motion.img
          src={src}
          alt={alt}
          loading={priority ? "eager" : "lazy"}
          style={{ y, scale, transformOrigin: "center", objectPosition: imgPosition }}
          className="absolute inset-0 h-full w-full object-cover will-change-transform"
        />
      </div>
    </div>
  );
}
